import { render, staticRenderFns } from "./view-expired-long-booking.vue?vue&type=template&id=724e3564&"
import script from "./view-expired-long-booking.vue?vue&type=script&lang=js&"
export * from "./view-expired-long-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports